import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class RateCodeService
{
    private readonly $apiService = inject(ApiService);


    Lookup(pCriteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IRateCodeService/LookupRateCode", pCriteria);
    }

    getRateCodesForServiceCode(serviceCodeId: string): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IRateCodeService/GetRateCodesForServiceCode", serviceCodeId);
    }

    getRateCodesForServiceCodeAndServiceAddress(
        serviceCodeId: string,
        serviceAddressId: string
    ): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth(
            "IRateCodeService/GetRateCodesForServiceCodeAndServiceAddress",
            serviceCodeId + ";" + serviceAddressId
        );
    }
}
